const labelsES = {
    "view": {
        "table": {
            "title": "Tu lista de sellos",
            "column": {
                "name": "Nombre",
                "owner": "Propietario",
                "company": "Compañía",
                "contract": "Contrato",
                "info": "Información",
                "status": "Estado",
                "action": "Acción"
            },
            "button": {
                "edit": "Editar",
                "export_csv": "Exportar CSV"
            },
            "placeholder": {
                "search": "Buscar..."
            },
            "label": {
                "approved": "Aprobado",
                "waiting_approval": "Esperando Aprobación"
            }
        },
        "message": {
            "success": "¡El sello ha sido eliminado!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo.",
            "notSubscribed": "No estás suscrito a ningún plan, por lo tanto solo puedes agregar <strong>3 etiquetas</strong>. Por favor, <3>suscríbete</3> a un plan para disponer de una cantidad ilimitada de etiquetas.",
            "subscriptionUpgrade": "Tu plan de suscripción actual no admite esta función. Por favor, <1>actualiza</1> tu plan de suscripción para disponer de esta función.",
            "subscriptionExpired": "Tu suscripción ha expirado. Por favor, <1>reanuda</1> tu suscripción para disponer de esta función.",
            "noAccess": "No tienes acceso a este módulo, por favor contacta al equipo de soporte para más información."
        },
        "modal": {
            "delete": {
                "header": "¿Eliminar sello {{labelName}}?",
                "body": "¿Estás seguro de que deseas eliminar el sello {{labelName}}? Esta acción no se puede deshacer."
            }
        }
    },
    "add": {
        "title": "Agregar Sello",
        "form": {
            "label": {
                "required": "Requerido",
                "name": "Nombre",
                "subuser": "Sub-Usuario",
                "logo": "Logo",
                "promo_graphic": "Gráfico Promocional",
                "primary_genre": "Género principal",
                "secondary_genre": "Género secundario",
                "year_established": "Año de Establecimiento",
                "releases_in_catalog": "Lanzamientos en catálogo",
                "soundcloud": "Soundcloud",
                "website": "Sitio web",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "youtube": "Youtube",
                "instagram": "Instagram",
                "mixcloud": "Mixcloud",
                "beatport": "Beatport"
            },
            "help_text": {
                "subuser": "Nota: Solo usa este menú desplegable si deseas agregar un sello para alguno de tus Sub-usuarios, de lo contrario déjalo sin seleccionar.",
                "logo": "Sube formatos JPG o PNG, resolución solo 1000x1000 px",
                "promo_graphic": "Sube formatos JPG o PNG, resolución solo 960x150px, máx 100kb"
            },
            "placeholder": {
                "subuser": "Seleccionar Sub-usuario..."
            },
            "button": {
                "reset": "Restablecer",
                "submit": "Enviar"
            },
            "message": {
                "success": "¡El sello ha sido agregado!",
                "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo."
            }
        },
        "modal": {
            "addLabel": {
                "header": "¿Agregar Sello {{labelName}}?",
                "body": "¿Estás seguro de que deseas crear un nuevo sello? Por favor, asegúrate de insertar un nombre de sello único. Para estar seguro, verifica si el nombre ya existe en tiendas como Beatport y Traxsource. Cada envío debe ser aprobado y registrado por el equipo de Music Link. Usualmente aprobamos y registramos nuevos sellos en un plazo de 48 horas.",
                "button": {
                    "confirm": "Confirmar",
                    "cancel": "Cancelar"
                }
            }
        },
        "message": {
            "success": "¡El sello ha sido agregado!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo."
        }
    },
    "update": {
        "title": "Editar Sello",
        "form": {
            "label": {
                "required": "Requerido",
                "name": "Nombre",
                "logo": "Logo",
                "promo_graphic": "Gráfico Promocional",
                "primary_genre": "Género principal",
                "secondary_genre": "Género secundario",
                "year_established": "Año de Establecimiento",
                "releases_in_catalog": "Lanzamientos en catálogo",
                "soundcloud": "Soundcloud",
                "website": "Sitio web",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "youtube": "Youtube",
                "instagram": "Instagram",
                "mixcloud": "Mixcloud",
                "beatport": "Beatport"
            },
            "help_text": {
                "logo": "Sube formatos JPG o PNG, resolución solo 1000x1000 px",
                "promo_graphic": "Sube formatos JPG o PNG, resolución solo 960x150px, máx 100kb"
            },
            "placeholder": {},
            "button": {
                "submit": "Enviar"
            },
            "message": {
                "success": "¡El sello ha sido actualizado!",
                "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo."
            }
        }
    }
};

export default labelsES;